export default class BatchMessageSenderDetail {
	public preSubmissionConfigurationId: string;
	public fromNumber: string;
	public isAlphaNumericSenderId: boolean;
	public partitionKey: string;

	public constructor() {
		this.preSubmissionConfigurationId = "";
		this.fromNumber = "";
		this.isAlphaNumericSenderId = false;
		this.partitionKey = "";
	}
}
